(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[83092],{

/***/ 90084:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestteethaligners",
      function () {
        return __webpack_require__(39559);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_bestteethaligners_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64730);
/* harmony import */ var _components_layouts_bestteethalignersWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40210);
/* harmony import */ var _components_bestteethaligners_advantages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40751);
/* harmony import */ var _components_bestteethaligners_whyUs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33735);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88737);








const OffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 33124)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33124)
            ]
    }
});
var __N_SSP = true;
function Home() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_7__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_bestteethalignersWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_bestteethaligners_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OffersList, {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_bestteethaligners_advantages__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_bestteethaligners_whyUs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ }),

/***/ 40751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Advantages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Advantages() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: " mt-24 sm:text-center max-w-[1080px] mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-[#4F9DCC] lg:text-2xl text-lg lg:leading-9 leading-7 font-bold",
                children: "What Are the Best Teeth Aligners?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-4 font-light",
                children: "The best aligners vary depending on individual needs and preferences. Some popular options include Invisalign, ClearCorrect, and SmileDirectClub. It's important to consult with a dental professional to determine the best option for your specific case."
            }),
            "ca",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-[#4F9DCC] lg:text-2xl text-lg lg:leading-9 leading-7 font-bold mt-14",
                children: "What Are the Advantages of Wearing Aligners?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-4 font-light",
                children: "The field of dentistry has undergone a remarkable transformation, revolutionizing both patient perception and traditional techniques. Invisible braces or aligners have emerged as a game-changer among the various options available. With aligners, patients can now easily embrace orthodontic treatment, bidding farewell to any associated pain."
            })
        ]
    });
}


/***/ }),

/***/ 64730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58887);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45464);








function MainBanner() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const isFormDisplayed = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["main-banner"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                classes: {
                    formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().form),
                    stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-title"]),
                    stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-description"]),
                    formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-button"]),
                    formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-field"]),
                    formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["steps-inner"]),
                    fieldsClassName: {
                        radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["radio-field"]),
                        checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["checkbox-field"])
                    },
                    fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["fields-wrapper"]),
                    tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tcpa),
                    labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["label-as-step-title"])
                },
                colors: {
                    primaryColor: "#f0c14c",
                    progressBar: "#aaaaaa"
                },
                showProgress: true
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 33735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WhyUs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/bestteethaligners/whyUs/style.module.scss
var style_module = __webpack_require__(74489);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/bestteethaligners/whyUs/icons/unmatchedComfort.tsx


function UnmatchedComfort() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        fill: "none",
        viewBox: "0 0 60 60",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_85",
                style: {
                    maskType: "alpha"
                },
                width: "60",
                height: "60",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H60V60H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_1_85)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#4F9DCC",
                    d: "M53.317 29.774a5.23 5.23 0 00.986-3.07c-.037-2.902-2.351-5.178-5.272-5.178H36.612V10.447C36.608 7.443 34.12 5 31.06 5c-2.9 0-5.248 2.12-5.827 5.197-.525 2.011-1.974 7.463-2.357 8.549-.638 1.8-1.963 3.997-3.262 4.719-1.08.602-3.99 1.74-6.065 2.52v-.913c0-.67-.55-1.214-1.227-1.214H4.227c-.677 0-1.227.544-1.227 1.214V52.44c0 .67.55 1.214 1.227 1.214h8.095c.678 0 1.227-.544 1.227-1.214v-.69c1.19.602 2.646 1.348 3.306 1.707l3.672 2.349c.199.128.43.194.668.194H46.33c2.908 0 5.274-2.341 5.274-5.216a5.155 5.155 0 00-.984-3.033c2.133-.668 3.682-2.647 3.682-4.977a5.155 5.155 0 00-.984-3.033A5.263 5.263 0 0057 34.717c-.035-2.352-1.557-4.292-3.682-4.943h-.001zM11.095 51.223h-5.64v-24.94h5.64v24.94zm40.634-13.67h-2.7c-.678 0-1.227.544-1.227 1.214 0 .67.55 1.214 1.227 1.214 1.554 0 2.818 1.253 2.818 2.79 0 1.538-1.264 2.788-2.818 2.788h-2.7c-.678 0-1.227.545-1.227 1.215s.55 1.214 1.227 1.214c1.556 0 2.82 1.253 2.82 2.79 0 1.538-1.267 2.788-2.82 2.788H21.556l-3.436-2.193c-.96-.53-3.385-1.758-4.57-2.355V28.576c1.737-.643 5.77-2.166 7.265-2.999 2.055-1.139 3.64-3.96 4.374-6.03.498-1.404 2.34-8.446 2.435-8.825.383-1.999 1.73-3.294 3.436-3.294 1.705 0 3.095 1.356 3.095 3.02v12.218l-.003.075c0 .67.55 1.214 1.227 1.214h13.65c1.561 0 2.8 1.22 2.818 2.79 0 1.54-1.264 2.791-2.818 2.791-.677 0-1.227.544-1.227 1.214 0 .67.55 1.215 1.227 1.215h2.7a2.795 2.795 0 012.815 2.788c0 1.547-1.263 2.8-2.814 2.8h-.001z"
                })
            })
        ]
    });
}
/* harmony default export */ var unmatchedComfort = (UnmatchedComfort);

;// CONCATENATED MODULE: ./src/components/bestteethaligners/whyUs/icons/enhancedAppearance.tsx


function EnhancedAppearance() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        fill: "none",
        viewBox: "0 0 60 60",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_77",
                style: {
                    maskType: "alpha"
                },
                width: "60",
                height: "60",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H60V60H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_1_77)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#4F9DCC",
                    d: "M51 22.09a21.11 21.11 0 00-5.632-14.378 20.971 20.971 0 00-13.891-6.66A20.949 20.949 0 0016.79 5.691a21.091 21.091 0 00-7.586 13.443 21.132 21.132 0 003.59 15.024 20.996 20.996 0 0012.837 8.53l-1.68 10.143a6.17 6.17 0 001.368 4.991A6.123 6.123 0 0030 60a6.124 6.124 0 004.68-2.178 6.17 6.17 0 001.368-4.99l-1.68-10.173A21.018 21.018 0 0046.3 35.32 21.15 21.15 0 0051 22.091zM31.623 43.166l1.68 10.144a3.323 3.323 0 01-.756 2.81 3.466 3.466 0 01-5.095 0 3.323 3.323 0 01-.757-2.81l1.68-10.144h3.248zM30 40.355a18.166 18.166 0 01-12.87-5.35 18.296 18.296 0 01-5.33-12.914c0-4.844 1.917-9.49 5.33-12.915A18.167 18.167 0 0130 3.826c4.826 0 9.456 1.924 12.868 5.35A18.297 18.297 0 0148.2 22.09a18.327 18.327 0 01-5.338 12.907 18.196 18.196 0 01-12.862 5.358zm0-33.719a15.372 15.372 0 00-10.89 4.527A15.483 15.483 0 0014.6 22.09c0 4.099 1.622 8.03 4.51 10.927A15.373 15.373 0 0030 37.545c4.084 0 8.001-1.628 10.89-4.527a15.482 15.482 0 004.51-10.927 15.51 15.51 0 00-4.52-10.92A15.4 15.4 0 0030 6.636zm0 28.1a12.58 12.58 0 01-8.91-3.704 12.668 12.668 0 01-3.69-8.941c0-3.354 1.327-6.57 3.69-8.941A12.579 12.579 0 0130 9.446c3.341 0 6.546 1.333 8.91 3.704a12.668 12.668 0 013.69 8.94 12.695 12.695 0 01-3.7 8.934 12.608 12.608 0 01-8.9 3.712zM28.6 53c0-.568.34-1.08.864-1.298a1.396 1.396 0 011.525.305c.4.401.52 1.006.304 1.53A1.4 1.4 0 0128.6 53zm5.18-37.512a1.35 1.35 0 010 1.966l-8.4 8.43a1.34 1.34 0 01-1.96 0 1.351 1.351 0 010-1.967l8.4-8.43a1.343 1.343 0 011.96 0zm0 8.43a1.35 1.35 0 010 1.966l-2.8 2.81a1.342 1.342 0 01-1.96 0 1.352 1.352 0 010-1.967l2.8-2.81a1.343 1.343 0 011.96 0z"
                })
            })
        ]
    });
}
/* harmony default export */ var enhancedAppearance = (EnhancedAppearance);

;// CONCATENATED MODULE: ./src/components/bestteethaligners/whyUs/icons/improvedSafety.tsx


function ImprovedSafety() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        fill: "none",
        viewBox: "0 0 60 60",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_80",
                style: {
                    maskType: "alpha"
                },
                width: "60",
                height: "60",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H60V60H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#4F9DCC",
                fillRule: "evenodd",
                clipRule: "evenodd",
                mask: "url(#mask0_1_80)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M50.682 12.558a3.238 3.238 0 00-2.453-3.142L30.953 5.097a3.23 3.23 0 00-1.572 0l-17.276 4.32a3.238 3.238 0 00-2.453 3.141v21.595c0 6.214 3.255 10.856 7.275 14.13 5.525 4.5 12.431 6.282 12.431 6.282.531.138 1.088.138 1.619 0 0 0 6.906-1.782 12.43-6.282 4.02-3.274 7.276-7.916 7.276-14.13V12.558zm-2.16 0v21.595c0 5.49-2.926 9.563-6.478 12.456-5.154 4.198-11.597 5.863-11.607 5.865a1.058 1.058 0 01-.54 0c-.01-.002-6.451-1.667-11.606-5.865-3.552-2.892-6.479-6.966-6.479-12.456V12.558c0-.496.337-.927.818-1.047l17.275-4.319c.172-.043.352-.043.524 0l17.275 4.319c.481.12.818.551.818 1.047zm-2.159 1.687c0-.496-.337-.928-.817-1.049L30.43 9.417a1.108 1.108 0 00-.524 0l-15.116 3.78c-.481.12-.818.552-.818 1.048v19.908c0 4.765 2.601 8.27 5.683 10.78 3.904 3.18 8.602 4.797 10.2 5.282.204.062.423.062.628 0 1.595-.485 6.294-2.102 10.199-5.281 3.082-2.51 5.682-6.017 5.682-10.781V14.245zm-2.159.842v19.066c0 4.041-2.274 6.977-4.887 9.107-3.392 2.762-7.433 4.245-9.148 4.79-1.718-.545-5.759-2.028-9.15-4.79-2.614-2.13-4.888-5.066-4.888-9.107V15.087l14.037-3.51 14.036 3.51z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M21.398 32.124l4.32 4.319a3.237 3.237 0 004.58 0l8.638-8.638a3.24 3.24 0 00-4.58-4.58l-6.348 6.347-2.03-2.028a3.24 3.24 0 00-4.58 4.58zm1.527-1.526a1.081 1.081 0 010-1.527 1.081 1.081 0 011.527 0l2.792 2.792a1.08 1.08 0 001.527 0l7.11-7.111a1.08 1.08 0 011.528 1.527l-8.638 8.637a1.078 1.078 0 01-1.527 0l-4.319-4.318z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var improvedSafety = (ImprovedSafety);

;// CONCATENATED MODULE: ./src/components/bestteethaligners/whyUs/index.tsx






const benefitsList = [
    {
        title: "Unmatched Comfort",
        description: "Aligners grant patients the freedom to live a normal life while wearing removable trays. Whether it's sleeping, eating, or practicing oral hygiene, the convenience of removing the trays as needed ensures a comfortable experience.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(unmatchedComfort, {})
    },
    {
        title: "Enhanced Appearance",
        description: "The introduction of clear trays has revolutionized the perception of braces, offering the advantage of wearing them discreetly and removing them at any given time. Say goodbye to self-consciousness and hello to a confident smile.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(enhancedAppearance, {})
    },
    {
        title: "Improved Safety",
        description: "Unlike traditional braces, which can cause discomfort and oral sores, aligners provide a safer alternative. The absence of brackets eliminates the possibility of food particles becoming trapped, lowering the risk of gum disease and decay brought on by bacterial growth.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(improvedSafety, {})
    }, 
];
function WhyUs() {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: " mt-12 lg:mb-24 mb-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col lg:flex-row justify-center gap-7 ",
                children: benefitsList.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `sm:w-[350px] w-[300px] lg:mx-0  mx-auto     lg:h-[448px] h-[470px] flex flex-col items-center px-6 relative ${(style_module_default()).shadowStyle}`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mt-9 block",
                                children: el.icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-7 font-bold lg:text-lg text-base text-[#4F9DCC]",
                                children: el.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center mt-6 min-h-[196px] font-light lg:leading-6",
                                children: el.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-[133px] h-[2px] bg-[#3D91BE] block absolute bottom-7"
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center mt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>scrollToTop(),
                    className: ` py-4 sm:px-24 px-12 sm:text-lg font-medium  ${(style_module_default()).buttonStyle}`,
                    children: "Get My Free Quote Now"
                })
            })
        ]
    });
}


/***/ }),

/***/ 58887:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","main-banner":"styles_main-banner__HH4eE","form":"styles_form__sMG03","steps-inner":"styles_steps-inner__55Ra5","step-title":"styles_step-title__dwtIR","label-as-step-title":"styles_label-as-step-title__23R5z","step-description":"styles_step-description__Dd56X","fields-wrapper":"styles_fields-wrapper__UFKfL","form-button":"styles_form-button__V3xKi","form-field":"styles_form-field__PwCUs","radio-field":"styles_radio-field__JFq3n","checkbox-field":"styles_checkbox-field__yWaXV","tcpa":"styles_tcpa__mGoN8"};

/***/ }),

/***/ 74489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shadowStyle":"style_shadowStyle__nAGN0","buttonStyle":"style_buttonStyle__zqRvU"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,40210,49774,92888,40179], function() { return __webpack_exec__(90084); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);